module.exports = __webpack_public_path__ + "img/m-hd.59fff1cd.jpg";